// src/app/types/examTypes.js
export const SUB_MENUS = {
  'exam-loc': '시험장',
  'exam-imp': '시험 시행',
  'exam-imp-series': '정기 시험',
  'exam-sheet': '문제지 정보',
  //  'sheet-create-5g': '문제지 생성',
  'user-group': '사용자 단체',
  'price-policy': '가격 정책',
  'exam-applicants': '접수 관리',
  'score': '성적 관리',
  'menu-ctrl': '메뉴 제어'
};

export const EXAM_TYPES = {
  LEET: {
    rid_cd_ext: process.env.REACT_APP_EXAM_TYPE_CODE_LEET,
    pathPrefix: 'leet',
    name: 'LEET',
    icon: 'gavel',
    rid_imp_sr: 3,
    uid_len: Number(process.env.REACT_APP_EXAM_TYPE_CODE_LEET_UID_LEN),
    getRouteSegments: (currentPath) => {
      const subMenu = Object.entries(SUB_MENUS).find(([key]) =>
        currentPath.includes(key)
      );
      return [
        { name: "시험관리", path: "/" },
        { name: "LEET" },
        { name: subMenu ? subMenu[1] : '' }
      ];
    }
  },

  G5: {
    rid_cd_ext: process.env.REACT_APP_EXAM_TYPE_CODE_G5,
    pathPrefix: 'g5',
    name: '5급 PSAT',
    icon: 'account_balance',
    rid_imp_sr: 1,
    uid_len: Number(process.env.REACT_APP_EXAM_TYPE_CODE_G5_UID_LEN),
    getRouteSegments: (currentPath) => {
      const subMenu = Object.entries(SUB_MENUS).find(([key]) =>
        currentPath.includes(key)
      );
      return [
        { name: "시험관리", path: "/" },
        { name: "5급 PSAT" },
        { name: subMenu ? subMenu[1] : '' }
      ];
    }
  },

  G7: {
    rid_cd_ext: process.env.REACT_APP_EXAM_TYPE_CODE_G7,
    pathPrefix: 'g7',
    name: '7급 PSAT',
    icon: 'groups',
    rid_imp_sr: 8,
    uid_len: Number(process.env.REACT_APP_EXAM_TYPE_CODE_G7_UID_LEN),
    getRouteSegments: (currentPath) => {
      const subMenuPattern = new RegExp(`/admin/g7/([^/]+)(?:/|$)`);
      const match = currentPath.match(subMenuPattern);
      const subMenuKey = match ? match[1] : '';
      const subMenuName = SUB_MENUS[subMenuKey] || '';

      return [
        { name: "시험관리", path: "/" },
        { name: "7급 PSAT" },
        { name: subMenuName }
      ];
    }
  },

  G72: {
    rid_cd_ext: process.env.REACT_APP_EXAM_TYPE_CODE_G72,
    pathPrefix: 'g72',
    name: '7급 2차',
    icon: 'group',
    rid_imp_sr: 7,
    uid_len: Number(process.env.REACT_APP_EXAM_TYPE_CODE_G72_UID_LEN),
    getRouteSegments: (currentPath) => {
      const subMenuPattern = new RegExp(`/admin/g72/([^/]+)(?:/|$)`);
      const match = currentPath.match(subMenuPattern);
      const subMenuKey = match ? match[1] : '';
      const subMenuName = SUB_MENUS[subMenuKey] || '';

      return [
        { name: "시험관리", path: "/" },
        { name: "7급 2차" },
        { name: subMenuName }
      ];
    }
  },

  BAR: {
    rid_cd_ext: process.env.REACT_APP_EXAM_TYPE_CODE_BAR,
    pathPrefix: 'bar',
    name: '변호사 시험',
    icon: 'group',
    rid_imp_sr: 12,
    uid_len: Number(process.env.REACT_APP_EXAM_TYPE_CODE_BAR_UID_LEN),
    getRouteSegments: (currentPath) => {
      const subMenuPattern = new RegExp(`/admin/bar/([^/]+)(?:/|$)`);
      const match = currentPath.match(subMenuPattern);
      const subMenuKey = match ? match[1] : '';
      const subMenuName = SUB_MENUS[subMenuKey] || '';

      return [
        { name: "시험관리", path: "/" },
        { name: "변호사 시험험" },
        { name: subMenuName }
      ];
    }
  }
};